import "./Images.scss";
import image4 from "../../assets/images/image-4.png";
import image8 from "../../assets/images/image-8.png";
import image9 from "../../assets/images/image-9.png";
import image12 from "../../assets/images/image-12.png";
import image17 from "../../assets/images/image-17.png";
import image18 from "../../assets/images/image-18.png";
import image20 from "../../assets/images/image-20.png";
import image29 from "../../assets/images/image-29.png";
import image32 from "../../assets/images/image-32.png";
import { motion } from "framer-motion";

const Images = () => {
  return (
    <div className="images">
      <motion.img
        src={image4}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
      <motion.img
        src={image8}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
      <motion.img
        src={image9}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
      <motion.img
        src={image12}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
      <motion.img
        src={image17}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
      <motion.img
        src={image18}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
      <motion.img
        src={image20}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
      <motion.img
        src={image29}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
      <motion.img
        src={image32}
        alt="home"
        className="images__img"
        whileHover={{ scale: 1.1 }}
      />
    </div>
  );
};

export default Images;
